"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.951 7.2H12.6V6H18v5.4h-1.2V8.049l-3.176 3.175-.848-.848L15.95 7.2zM8.048 16.8H11.4V18H6v-5.4h1.2v3.351l3.176-3.175.848.848L8.048 16.8z" }), "Expand");
//# sourceMappingURL=Expand.js.map